
// this file is automatically generated by git.version.ts script
export const versions = {
  version: '0.6.96',
  revision: '6a9d32d',
  branch: 'master'
};